import { Handshake, Sparkles } from "lucide-react";

const AudienceWhy = () => {
  return (
    <section className="py-20 px-4 bg-background">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            Vem träffarna passar för
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Ett nätverk för dig som bygger affärer genom relationer.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          <div className="rounded-2xl border-2 border-border bg-card p-8 hover:border-accent transition-all duration-300 hover:shadow-lg">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-accent text-white mb-5">
              <Handshake className="w-6 h-6" />
            </div>
            <h3 className="text-xl font-bold text-primary mb-3">
              Vem träffarna passar för
            </h3>
            <p className="text-muted-foreground leading-relaxed">
              Affärsnätverket passar företagare, konsulter, säljare och rådgivare
              som bygger affärer genom förtroende och långsiktiga relationer.
            </p>
          </div>

          <div className="rounded-2xl border-2 border-border bg-card p-8 hover:border-accent transition-all duration-300 hover:shadow-lg">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-accent text-white mb-5">
              <Sparkles className="w-6 h-6" />
            </div>
            <h3 className="text-xl font-bold text-primary mb-3">
              Varför det fungerar
            </h3>
            <p className="text-muted-foreground leading-relaxed">
              Många affärer börjar inte med en pitch. De börjar med ett samtal, en
              fråga eller en ny kontakt. Därför bygger Affärsnätverket på
              nyfikenhet, tydlighet och naturliga möten mellan människor.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AudienceWhy;
